import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { placesEnvironment } from '../places-environment';
import { placeSchema } from '../schemas/place.schema';

/**
 * Get all places in a place set
 * @param setId Place set identifier
 * @returns An array of all places in the place set
 */
export function getPlacesSetsPlacelist(this: unknown, setId: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        placesEnvironment.resolve(this).placeSetPlacelistUrl(String(setId)),
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.array(
        placeSchema.pick({
          trimblePlaceId: true,
          name: true,
        })
      )
    )
  );
}
